module.exports = __webpack_public_path__ + "static/media/Reservation-09.13173cfc.svg";